export const TRADVERA_OWNER_EMAILS = Object.freeze([
  "waelpg@gmail.com",
  "wael@xorax.io",
]);

export function normalizeOwnerEmail(value: unknown) {
  return typeof value === "string" ? value.trim().toLowerCase() : "";
}

export function isTradveraOwnerEmail(value: unknown) {
  return TRADVERA_OWNER_EMAILS.includes(normalizeOwnerEmail(value));
}

export function localPreviewAllowed() {
  return typeof window !== "undefined" && ["127.0.0.1", "localhost"].includes(window.location.hostname);
}

export function normalizePinDigits(value: unknown) {
  if (typeof value !== "string") return "";
  return value
    .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 0x06f0))
    .replace(/\D/g, "")
    .slice(0, 4);
}
